import { Grid } from '@material-ui/core'
import React from 'react'
import styled from 'styled-components'
import { useOnboarding } from '../../../contexts/OnboardingContext'
import OnboardingSectionTitle from '../../../_global/OnboardingSectionTitle'
import ServiceLineForm from './Form'

const GridContainer = styled(Grid)`
  padding-right: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media only screen and (max-width: 900px) {
    padding: 0px;
  }
`
const normalizeServiceLineValue = (serviceLine) => {
  switch (serviceLine) {
    case 'CFO':
      return 'CFO'
    case 'Full Charge Bookkeeping':
      return 'FULL_CHARGE_BOOKKEEPING'
    case 'FP&A':
      return 'FPA'
    case 'Tax Preparation':
      return 'TAX_PREP'
    case 'CPA/Accounting Advisory':
      return 'CPA_ACCOUNTING_ADVISORY'
    default:
      return ''
  }
}

const ServiceLine = () => {
  const {
    currentExpert: {
      legacyFreelancerId,
      legacyMetadata: { primaryServiceLine },
      onboardingStep,
    },
  } = useOnboarding()

  const serviceLine = normalizeServiceLineValue(primaryServiceLine)

  const initialValues = { legacyFreelancerId, serviceLine, isSaveAndExit: false, onboardingStep }
  return (
    <GridContainer>
      <Grid item xs={8}>
        <OnboardingSectionTitle
          title="Primary Role"
          description={
            'Please select the role that best describes your experience. Clients we identify for you are based on your overall experience and preferences and not determined by this title.'
          }
        ></OnboardingSectionTitle>
      </Grid>
      <Grid item xs={8}>
        <ServiceLineForm initialValues={initialValues} />
      </Grid>
    </GridContainer>
  )
}

export default ServiceLine
